<template>
  <div :class="b()" :style="styleSizeName">
    <div :class="b('title')" v-html="titleFormatter && titleFormatter(dataChart)"></div>
    <div v-show="hasData" :ref="id" :style="styleChartName"></div>
    <template v-if="!hasData">
      <empty></empty>
    </template>
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'pie2',
  mixins: [init],
  computed: {
    labelShow() {
      return this.vaildData(this.option.labelShow, false);
    },
    x2() {
      return this.option.gridX2 || 20;
    },
    fontSize() {
      return this.option.fontSize || 14;
    },
    hasData() {
      return this.dataChart?.length > 0;
    }
  },
  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart) || [];

      const option = {
        title: this.ishasprop(
          this.option.titleShow,
          {
            text: this.option.title,
            subtext: this.option.subtext || '',
            textStyle: {
              color: this.option.titleColor || '#333',
              fontSize: this.option.titleFontSize || 16
            },
            left: this.option.titlePostion || 'auto',
            subtextStyle: {
              color: this.option.subTitleColor || '#aaa',
              fontSize: this.option.subTitleFontSize || 14
            }
          },
          {}
        ),
        tooltip: (() => {
          return Object.assign(
            (() => {
              if (this.formatter) {
                return {
                  formatter: name => {
                    return this.formatter(name, this.dataChart);
                  }
                };
              }
              return {};
            })(),
            {
              textStyle: {
                fontSize: this.option.tipFontSize,
                color: this.option.tipColor || '#fff'
              }
            }
          );
        })(),
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        legend: {
          type: this.option.legendType || 'plain',
          show: this.vaildData(this.option.legend, false),
          orient: this.option.legendOrient || 'vertical',
          x: this.option.legendPostion || 'left',
          bottom: 0,
          pageIconColor: this.option.pagerBtnBgc || '#fff',
          pageTextStyle: {
            color: this.option.pagerTextBgc || '#fff'
          },
          pageIconSize: this.option.pagerBtnSize || [15, 15],
          icon: this.option.legendIcon || 'roundRect',
          right: this.x2,
          textStyle: {
            fontSize: this.option.legendFontSize || 12
          },
          data: (() => {
            if (Array.isArray(optionData)) {
              return optionData.map((ele, index) => {
                return {
                  name: ele.name,
                  textStyle: this.ishasprop(
                    !this.switchTheme,
                    {
                      color: this.getColor(index, true)
                    },
                    {}
                  )
                };
              });
            } else {
              return null;
            }
          })()
        },
        series: (() => {
          this.option.barColor || [];
          const list = [
            {
              type: 'pie',
              roseType: this.option.roseType ? 'radius' : '',
              radius: this.option.radius ? ['45%', '65%'] : '65%',
              center: ['50%', '55%'],
              animationType: 'scale',
              animationEasing: 'elasticOut',
              animationDelay: function() {
                return Math.random() * 200;
              },
              label: {
                normal: {
                  show: this.labelShow,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: this.fontSize
                  }
                }
              },
              data: (() => {
                let list = optionData;
                if (this.option.notCount) {
                  list = list.filter(ele => {
                    if (ele.value !== 0 && ele.value) {
                      return true;
                    }
                  });
                }
                if (this.option.sort) {
                  list.sort(function(a, b) {
                    return a.value - b.value;
                  });
                }
                return list;
              })(),
              itemStyle: this.ishasprop(
                !this.switchTheme,
                {
                  color: params => this.getColor(params.dataIndex)
                },
                {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              )
            }
          ];
          return list;
        })()
      };

      this.myChart.resize();
      this.myChart.setOption(option, true);
      this.chartClick();
    }
  }
};
</script>
